import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text, Subtitle, Warning } from 'app/src/styles';

import { UPDATE_ACCESS_TOKEN } from './queries';

const FIELDS = {
  name: {
    hint: 'Optional. A name or tag for this token, for your reference'
  },
};

const EditAccessToken = ({ accessToken, setShow, refetch }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: accessToken })
  });

  const [updateAccessToken] = useMutation(UPDATE_ACCESS_TOKEN, {
    onCompleted: () => {
      refetch();
      setShow(false);
    }
  });

  const onSubmit = input => {
    updateAccessToken({ variables: prepareInput(input, FIELDS) });
  };

  return (
    <Modal title="Update API Access Token" setShow={setShow}>
      <Subtitle>
        {accessToken.dealer.label} - {accessToken.token.substr(0, 5)}
      </Subtitle>

      <Fields fields={FIELDS} control={control} errors={errors} />

      <Button label="Update" onPress={handleSubmit(onSubmit)} wide />
    </Modal>
  );
};

export default EditAccessToken;
